import { render, staticRenderFns } from "./AbkFooterNavbar.vue?vue&type=template&id=25d5465e&scoped=true&"
import script from "./AbkFooterNavbar.vue?vue&type=script&lang=js&"
export * from "./AbkFooterNavbar.vue?vue&type=script&lang=js&"
import style0 from "./AbkFooterNavbar.vue?vue&type=style&index=0&id=25d5465e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d5465e",
  null
  
)

export default component.exports